import classNames from 'classnames';
import * as React from 'react';
import styles from './NavButtons.module.css';

export type NavButtonVariant = 'light' | 'dark';

export interface NavButtonProps {
    buttonKey: string;
    className?: string;
    variant?: NavButtonVariant;
}

interface BasketButtonProps {
    children?: (React.ReactElement<NavButtonProps> | boolean)[];
}

export const NavButtons: React.FC<React.PropsWithChildren<BasketButtonProps>> = props => {
    const { children } = props;
    const childrenButtons = (children ? children.filter(c => !!c) : []) as React.ReactElement<NavButtonProps>[];

    return (
        <ul className={styles.List}>
            {children &&
                childrenButtons.map(childButton => {
                    const { props: navButtonProps } = childButton;
                    const { buttonKey, className } = navButtonProps;

                    return (
                        <li key={buttonKey} className={classNames(styles.Item, className)}>
                            {childButton}
                        </li>
                    );
                })}
        </ul>
    );
};
